import templateUrl from './menu-sequence.html';

export const menuSequenceComponent = {
    bindings: {
        details: '<',
        slugUrl: '@',
        menuName: '@',
        parentSlug: '@'
    },

    templateUrl,

    controller: class MenuSequenceComponent {
        constructor($state, toastr, ModalService, MenuSequenceService, CompareObjectService) {
            'ngInject';

            this.$state = $state;
            this._toastr = toastr;
            this.modalService = ModalService;
            this.menuSequenceService = MenuSequenceService;
            this.compareObjectService = CompareObjectService;
        }

        $onInit() {
            this.details = this.menuSequenceService.getMenuSequence(this.details);
            this.saveData = angular.copy(this.details);
        }

        //after submit set new sort Order
        onSubmit() {
            const obj = angular.copy(this.details);
            obj.map((item, index) => {
                item.sortOrder = this.saveData[index].sortOrder;
                return item;
            });
            this.menuSequenceService.updateMenuSequence(obj, this.menuName)
                .then((result) => {
                    this._toastr.success("Content Sequence Changed");
                    this._redirectToParentState(this.parentSlug);
                }).catch((err) => {
                    this._toastr.error("something went wrong");
                });
        }

        //on cancel page must redirect to home banner page
        onCancel() {
            const _details = angular.copy(this.details);
            const isUpdated = this.compareObjectService.deepCompareObjectHasChanged(this.saveData, _details, true);
            if (isUpdated) {
                this.modalService.open({
                    details: {
                        bodyMessage: 'Changes done will be reverted. Continue?'
                    },
                    buttons: [{
                        name: 'No'
                    }, {
                        name: 'Yes',
                        isPrimary: true,
                        action: _onSubmit.bind(this)
                    }]
                });
            } else {
                this._redirectToParentState(this.parentSlug);
            }

            function _onSubmit() {
                this._redirectToParentState(this.parentSlug);
            }
        }

        _redirectToParentState(slug) {
            this.$state.go('app.dashboard.DynamicMenus', {
                url: slug
            });
        }
    }
};


// WEBPACK FOOTER //
// ./src/app/components/menu-sequence/menu-sequence.component.js